export default "__VITE_ASSET__DsgC$Xni__"